import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApiClient,
  AttachmentGroupInfo,
  AttachmentInfo,
  AttachmentSectionInfo,
  AzureBlobUploadResult,
  FileParameter,
  UpdateAttachmentRequest,
} from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class AttachmentService {
  private readonly sdk = inject(ApiClient);

  getAttachmentsByOpportunityId(
    opportunityId: string
  ): Observable<AttachmentInfo[]> {
    return this.sdk.getAttachments(opportunityId);
  }

  getAttachmentGroups(): Observable<AttachmentGroupInfo[]> {
    return this.sdk.getAttachmentGroups();
  }

  getAllAttachmentGroups(): Observable<AttachmentGroupInfo[]> {
    return this.sdk.getAllAttachmentGroups();
  }

  getAttachmentSections(): Observable<AttachmentSectionInfo[]> {
    return this.sdk.getAttachmentSections();
  }

  deleteAttachment(id: string): Observable<void> {
    return this.sdk.deleteAttachment(id);
  }

  updateAttachment(
    id: string,
    request: UpdateAttachmentRequest
  ): Observable<AttachmentInfo> {
    return this.sdk.updateAttachment(id, request);
  }

  uploadAttachment(
    opportunityId: string,
    file: FileParameter,
    attachmentGroupId: string | null,
    description: string | null,
    attachmentSectionId: string | null
  ): Observable<AzureBlobUploadResult[]> {
    return this.sdk.uploadAttachment(
      opportunityId,
      file,
      attachmentGroupId,
      attachmentSectionId,
      description
    );
  }
}
